import React from 'react';

import LoaderCircleIcon from '@liquidweb-dev/undercurrent/icons/animated/LoaderCircle';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Button from '@liquidweb-dev/undercurrent/Button';
import DrawerContent from '@liquidweb-dev/undercurrent/DrawerContent';
import DrawerFooter from '@liquidweb-dev/undercurrent/DrawerFooter';

interface BackupSettingsLoadingProps {
	onClose?: () => void;
}

const BackupSettingsLoading: React.FC<BackupSettingsLoadingProps> = ({
	onClose,
}) => {
	return (
		<>
			<DrawerContent>
				<Stack flex={1} justifyContent="center" alignItems="center">
					<LoaderCircleIcon
						sx={({ size }) => ({ height: size.lg, width: size.lg })}
					/>
				</Stack>
			</DrawerContent>
			<DrawerFooter spacing={100}>
				<Button loading size="large">
					Loading
				</Button>
				<Button variant="ghost" onClick={onClose} size="large">
					Cancel
				</Button>
			</DrawerFooter>
		</>
	);
};

export default BackupSettingsLoading;
